import { Profile } from '@graphql/__generated__/graphql';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import {
  BasicStatProps,
  KeyBioHighlightsProps,
} from '@stadionhq-v3/football-ui';
import { Translations } from '@lib/dictionary-keys/__generated__';
import dayjs from '@lib/dayjs';
import { Locale } from '@core/constants/locales.constants';

const keyBioHighlightsTransform = (
  { dateOfBirth, dateOfDebut, placeOfBirth, height }: CleanContentful<Profile>,
  dictionary: {
    dateOfBirth: Translations['profile']['label']['dateOfBirth'];
    dateOfDebut: Translations['profile']['label']['dateOfDebut'];
    placeOfBirth: Translations['profile']['label']['placeOfBirth'];
    height: Translations['profile']['label']['height'];
  },
  locale: Locale
): KeyBioHighlightsProps => {
  const formatDate = (value: string): string => {
    if (!value) {
      return '-';
    }

    const djs = dayjs(locale);

    const parsedDate = djs(value);

    if (parsedDate.isValid()) {
      return parsedDate.format('D MMMM YYYY');
    }

    return value.toString();
  };

  const formatHeight = (value: string): string => {
    const trimmed = value.trim();
    return /\d$/.test(trimmed) ? `${trimmed}cm` : trimmed;
  };

  const items = {
    dateOfBirth,
    dateOfDebut,
    placeOfBirth,
    height,
  };

  const basicStats: BasicStatProps[] = Object.entries(items)
    .filter(([, value]) => value)
    .map(([key, value]) => {
      const stringValue = value as string;
      let information = stringValue;
      if (key.includes('date')) information = formatDate(stringValue);
      else if (key === 'height') information = formatHeight(stringValue);
      return {
        title: dictionary[key as keyof typeof dictionary],
        information,
      };
    });

  return { basicStats };
};

export default keyBioHighlightsTransform;
